export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8617.13ae6ec1.jpg";